import {
  CentraApiResult,
  CentraErrorsResponse,
  CentraSelectionResponse,
  CentraTokenHandler,
  selectionResponseSchema,
} from "@made-people/centra-checkout-api";
import { BffClient } from "@made-people/gears-bff-client";
import { FrontendContextV1 } from "@made-people/nestjs-bff-service";
import { gaCreateSession } from "../../utils/ga-create-session";

export async function bffInitializeSelection(
  bffClient: BffClient,
  centraTokenHandler: CentraTokenHandler,
  frontendContext: FrontendContextV1,
): Promise<CentraApiResult<CentraSelectionResponse, CentraErrorsResponse>> {
  const token = centraTokenHandler.getToken() ?? "";

  const selection = await bffClient.initializeSelection(frontendContext, token);

  if (!selection) {
    return {
      error: {
        token,
        errors: { selection: "not found" },
      },
      success: null,
    };
  }

  const parsedSelection = selectionResponseSchema.safeParse(selection);

  if (!parsedSelection.success) {
    return {
      error: {
        token,
        errors: { selection: "not found" },
      },
      success: null,
    };
  }

  centraTokenHandler.setToken(parsedSelection.data.token);

  // Miss mary specific old backend ga4 tracking thing
  gaCreateSession(parsedSelection.data.token, frontendContext);

  return { error: null, success: parsedSelection.data };
}
